import { GQL } from "@binale-tech/shared";

import type { AgentStep } from "../runner/types";

export const uploadStep: AgentStep = {
    id: "upload",
    product: [GQL.IProductKey.Dms],
    async run(ctx, io) {
        if (!ctx.uploadRequested) return { status: "skipped" };

        const reported = new Set<string>();
        const result = await io.panel({
            type: "upload",
            onUploaded: (ids) => ids.forEach((id) => reported.add(id)),
        });
        const ids = [...reported];
        if (ids.length === 0) return { status: result === "skipped" ? "skipped" : "nothing" };

        for (const id of ids) {
            if (!ctx.created.documentIds.includes(id)) ctx.created.documentIds.push(id);
        }
        io.post({ kind: "done", textId: "app.agent.upload.done", values: { count: ids.length } });
        return { status: "done", summary: [{ textId: "app.agent.report.uploaded", values: { count: ids.length } }] };
    },
};
